import { init, useOnboard } from "@web3-onboard/vue";

import injectedModule from "@web3-onboard/injected-wallets";
import walletConnectModule from "@web3-onboard/walletconnect";
import coinbaseWalletModule from "@web3-onboard/coinbase";
import ledgerModule from "@web3-onboard/ledger";

import { ethers } from "ethers";
import Web3 from "web3";
import { Buffer } from 'buffer';

import { AwakenedZoofrenz } from "./AwakenedZoofrenz";
import { ZoofrenzFirstClassPass } from "./ZoofrenzFirstClassPass";
import { FrenshipToken } from "./FrenshipToken";
import { ZooFrenzToken } from "./ZooFrenzToken";
import { WarmWallet } from "./WarmWallet";

import http from "../api/http";

import zoofrenzIcon from '../../public/img/favicon.png'
const MAINNET_RPC_URL =
  "https://mainnet.infura.io/v3/28c6a50585b542a2a30d7dc9c5e3bfef";

const LOGO_URL =
  "https://zoofrenz-assets.s3.us-west-1.amazonaws.com/images/ZOOFRENZ_LOGO.svg";
const APP_DESCRIPTION = "ZooFrenz using Onboard";

const EVENT_WALLET_CONNECT_UPDATED = "wallet-connect-event";
const EVENT_NFT_LIST_UPDATED = "render-vrm-event";

let connectWallet, connectedWallet, alreadyConnectedWallets;

// let wallets,
// disconnectConnectedWallet;
window.Buffer = Buffer;

var Web3Manager = {
  async initOnboard() {
    
    const injected = injectedModule();

    const walletConnect = walletConnectModule({
      projectId: "1ef5fee7c2e350004c5888741b365c1f",
      /**
       * Chains required to be supported by all wallets connecting to your DApp
       */
      requiredChains: [1],
      /**
       * Defaults to `appMetadata.explore` that is supplied to the web3-onboard init
       * Strongly recommended to provide atleast one URL as it is required by some wallets (i.e. MetaMask)
       * To connect with WalletConnect
       */
      dappUrl: 'https://www.zoofrenz.com',
      connectFirstChainId: true,
    });

    const coinbaseWalletSdk = coinbaseWalletModule({ darkMode: true });

    const ledger = ledgerModule({
      projectId: "1ef5fee7c2e350004c5888741b365c1f",
    });

    this.onboard = init({
      wallets: [injected, walletConnect, coinbaseWalletSdk, ledger],
      chains: [
        {
          id: "0x1",
          token: "ETH",
          label: "Ethereum Mainnet",
          rpcUrl: MAINNET_RPC_URL,
        },
      ],
      appMetadata: {
        name: "ZooFrenz",
        icon: zoofrenzIcon,
        logo: LOGO_URL,
        description: APP_DESCRIPTION,
        recommendedInjectedWallets: [
          { name: "Coinbase", url: "https://wallet.coinbase.com/" },
          { name: "MetaMask", url: "https://metamask.io" },
        ],
      },
      connect: {
        showSidebar: true,
        disableClose: true,
      },
      accountCenter: {
        desktop: {
          minimal: true,
          position: "bottomRight",
        },
        mobile: {
          position: "bottomRight",
          enabled: true,
          minimal: true,
        },
      },
    });

    ({
      // wallets,
      connectWallet,
      // disconnectConnectedWallet,
      connectedWallet,
      alreadyConnectedWallets,
    } = useOnboard());

    if (alreadyConnectedWallets.value[0] != null) {
      this.wallets = await connectWallet({
        autoSelect: {
          label: alreadyConnectedWallets.value[0],
          disableModals: true,
        },
      });

      await this.onWalletConnected();
    } else {
      window.vrmItems = [];
      window.nftList = [];

      const event = new Event(EVENT_NFT_LIST_UPDATED);
      window.dispatchEvent(event);

      window.walletConnected = false;
      const walletEvent = new Event(EVENT_WALLET_CONNECT_UPDATED);
      window.dispatchEvent(walletEvent);
    }
  },
  async connectWallet() {
    this.wallets = await connectWallet();

    if (connectedWallet.value.accounts.length > 0) {
      await this.onWalletConnected();

      var responseData = await http.requestSign(this.walletAddress);
      await this.signMessage(responseData);
    }
  },
  async onWalletConnected() {
    this.customOnBoardPosition();
    this.walletAddress = String(connectedWallet.value.accounts[0].address);

    window.walletConnected = true;
    const event = new Event(EVENT_WALLET_CONNECT_UPDATED);
    window.dispatchEvent(event);

    const ethersProvider = new ethers.providers.Web3Provider(
      connectedWallet.value.provider,
      "any"
    );

    this.signer = ethersProvider.getSigner();

    this.web3 = new Web3(connectedWallet.value.provider);

    AwakenedZoofrenz.init(this.web3);
    ZoofrenzFirstClassPass.init(this.web3);
    FrenshipToken.init(this.web3);
    ZooFrenzToken.init(this.web3);
    WarmWallet.init(this.web3);
    const state = this.onboard.state.select();
    state.subscribe((update) => {
      if (update.wallets.length == 0) {
        this.onWalletDisconnected();
      }
    });    
    window.vrmItems = [];
    window.nftList = [];
    
    const event2 = new Event(EVENT_NFT_LIST_UPDATED);
    window.dispatchEvent(event2);

    await this.listAllZoofrenzToken(this.walletAddress);

    this.coldWallets = await WarmWallet.getColdWallets(this.walletAddress);
    this.coldWallets.forEach(element => {
      this.listAllZoofrenzToken(element);
    });
    
  },
  onWalletDisconnected() {
    window.walletConnected = false;

    const event = new Event("wallet-connect-event");
    window.dispatchEvent(event);
    window.vrmItems = [];
    window.nftList = [];

    const event2 = new Event(EVENT_NFT_LIST_UPDATED);
    window.dispatchEvent(event2);
  },
  async listAllZoofrenzToken(walletAddress) {
    window.nftList = [];
    await this.listAwakenedZoofrenzToken(walletAddress);
    await this.listZoofrenzToken(walletAddress);

    this.listTokenIdLIst();
  },

  async listAwakenedZoofrenzToken(walletAddress) {
    try {
      const nfts = await AwakenedZoofrenz.tokensOfOwner(walletAddress);
      const tokendIdString = String(nfts);
      const nftIdPair = await http.getEditionIdList(tokendIdString);

      for (let key in nftIdPair) {
        window.nftList.push({ walletAddress,tokenId: key, editionId: nftIdPair[key] });
      }
    } catch (error) {
      console.error(error);
    }
  },

  async listZoofrenzToken(walletAddress) {
    const balanceOfZoofrenzTokenPromise = ZooFrenzToken.balanceOf(
      walletAddress
    );
    const bal = await balanceOfZoofrenzTokenPromise;

    for (var i = 0; i < bal; i++) {
      const ZoofrenzTokenTokenOfOwnerByIndexPromise =
        ZooFrenzToken.tokenOfOwnerByIndex(walletAddress, i);
      const token = await ZoofrenzTokenTokenOfOwnerByIndexPromise;
      const tokenId = String(token);

      window.nftList.push({ walletAddress,tokenId: tokenId, editionId: tokenId });
    }
  },
  listTokenIdLIst() {
    window.vrmItems = [];

    window.nftList.forEach((element) => {
      window.vrmItems.push({
        walletAddress:element.walletAddress,
        id: "#" + element.editionId,
        imgUrl:
          "https://zoofrenz-assets-singapore.s3.ap-southeast-1.amazonaws.com/nft-images-256x256/" +
          element.editionId +
          ".png",
        tokenId: element.tokenId,
        editionId: element.editionId,
      });

      const event = new Event(EVENT_NFT_LIST_UPDATED);
      window.dispatchEvent(event);
    });
  },
  async signMessage(mes) {
    const signature = await this.signer.signMessage(mes);

    await http.verifySignedMessage(this.walletAddress, signature);
  },
  customOnBoardPosition() {
    const elem = document.getElementsByTagName("onboard-v2");
    if (!elem || !elem.item(0)) return;
    const childNodes = Array.from(elem.item(0).shadowRoot.childNodes);
    childNodes.forEach((childNode) => {
      if (childNode.nodeName === "DIV") {
        if (
          childNode.className.indexOf("container") >= 0 &&
          childNode.className.indexOf("svelte-") >= 0
        ) {
          childNode.style.zIndex = "100";
        }
      }
    });
  },
};

export default Web3Manager;
